import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './types';

interface IProperties {
  countProperties: number;
  newAddedOfCurrentWeek: number;
}

interface IClients {
  countClients: number;
  newClientsOfCurrentWeek: number;
}

interface ISales {
  agentid: number;
  sale: number;
  agentname: string;
}

interface IPropertiesByCity {
  total: number;
  name: string;
}

interface ICustomerByRoles {
  count: number;
  name: string;
}

interface ICustomerByfoundUsOn {
  count: number;
  founduson: string;
}

interface IPropertiesWithType {
  id: number;
  name: string;
  createdonutc: string;
}

interface IAssignees {
  id: number;
  customer: string;
  picture: string;
}

interface ILatestTask {
  id: number;
  title: string;
  description: string;
  status: number;
  assignees: IAssignees[];
}

interface IMyLatestTodo {
  id: number;
  title: string;
  description: string;
  status: number;
}

interface IUpcomingAppointment {
  id: number;
  title: string;
  description: string;
  status: number;
  assignees: IAssignees[];
}

interface IInquiriesCall {
  id: number;
  title: string;
  description: string;
  status: number;
  assignees: IAssignees[];
}
interface IDashboardData {
  properties: IProperties;
  clients: IClients;
  sales: ISales[];
  propertiesByCity: IPropertiesByCity[];
  propertiesWithType: IPropertiesWithType[];
  latestTasks: ILatestTask[];
  myLatestTodo: IMyLatestTodo[];
  upcomingAppointment: IUpcomingAppointment[];
  inquiriesCall: IInquiriesCall[];
  customerByRoles: ICustomerByRoles[];
  customerByfoundUsOn: ICustomerByfoundUsOn[];
}

interface IDashboardSoldByType {
  name: string;
  count: number;
}

export interface IState {
  dashboardData: {
    status: StateStatus | null | undefined;
    data: IDashboardData | null;
  };
  dashboardSoldByType: {
    status: StateStatus | null | undefined;
    data: IDashboardSoldByType[] | null;
  };
  dashboardSale: {
    status: StateStatus | null | undefined;
    data: ISales[] | null;
  };
}

const initialState: IState = {
  dashboardData: {
    status: null,
    data: null,
  },
  dashboardSoldByType: {
    status: null,
    data: null,
  },
  dashboardSale: {
    status: null,
    data: null,
  },
};

const DashboardReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.GET_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          status: action.status,
          data: action.data,
        },
      };

    case Types.GET_DASHBOARD_SALE:
      return {
        ...state,
        dashboardSale: {
          ...state.dashboardSale,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.dashboardSale.data
              : action.data,
        },
      };
    case Types.GET_DASHBOARD_SOLD_BY_TYPE:
      return {
        ...state,
        dashboardSoldByType: {
          ...state.dashboardSoldByType,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.dashboardSoldByType.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default DashboardReducer;
